/**
 * How this browser signs in. After a ChurchTools sign-in, an ended session goes straight back to the
 * IdP (no password while its session lasts; ChurchTools is asked again) instead of the login page.
 * A PIN sign-in, an explicit logout (for this tab) or a failed sign-in keep the login page.
 */
const METHOD_KEY = 'plan.signInMethod';
const LOGGED_OUT_KEY = 'plan.loggedOut';

const safely = <T,>(fn: () => T, fallback: T): T => {
    try {
        return fn();
    } catch {
        return fallback;
    }
};

export const signInMethod = {
    rememberChurchTools: () => safely(() => localStorage.setItem(METHOD_KEY, 'churchtools'), undefined),
    rememberCode: () => safely(() => localStorage.setItem(METHOD_KEY, 'code'), undefined),
    markLoggedOut: () => safely(() => sessionStorage.setItem(LOGGED_OUT_KEY, '1'), undefined),
    /** True when the login page should go straight to ChurchTools. */
    goStraightToChurchTools: (): boolean =>
        safely(() => localStorage.getItem(METHOD_KEY) === 'churchtools' && sessionStorage.getItem(LOGGED_OUT_KEY) !== '1', false),
    /** A deliberate sign-in ends the "just logged out" pause. */
    clearLoggedOut: () => safely(() => sessionStorage.removeItem(LOGGED_OUT_KEY), undefined),
};
